/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
//import { Link } from "react-router-dom";
import data from "../data/contact.json";
//import { contactFormAction } from "../global";
import { useForm, ValidationError } from '@formspree/react';

const Contact = ({ isBg }) => {
  const { contact } = data;
  const [state, handleSubmit] = useForm("mayrvarb");

  return (
    // <!-- ========== Contact section start ========== -->
    <section
      id="contact"
      className={`p-80px-tb ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{contact.subtitle}</span>
              <h2 className="display-6">{contact.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* <!--  contact form area start --> */}
          <div
            className="col-lg-8 col-md-6 col-sm-12 m-25px-b"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="contact-form-box">
              <form
                id="contact-form"
                method="post"
                //action={contactFormAction.link}*
                onSubmit={handleSubmit}
              >
                <div className="message col">
                  <p className="email-loading alert alert-warning">
                    <img src="assets/images/loading.gif" alt="" />
                    &nbsp;&nbsp;&nbsp;Sending...
                  </p>
                  <p className="email-success alert alert-success">
                    <i className="icofont-check-circled"></i> Your quote has
                    successfully been sent.
                  </p>
                  <p className="email-failed alert alert-danger">
                    <i className="icofont-close-circled"></i> Something went
                    wrong!
                  </p>
                </div>
                <div className="mb13">
                  <input
                    name="name"
                    className="contact-name"
                    id="contact-name"
                    type="text"
                    placeholder="Nom"
                    required
                  />
                </div>
                <div className="mb13">
                  <input
                    name="email"
                    className="contact-email"
                    id="contact-email"
                    type="email"
                    placeholder="Email"
                    required
                  />
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                </div>
                <input
                  name="subject"
                  type="hidden"
                  value="Atandian: Nouveau message depuis le site internet"
                />
                <div className="mb30">
                  <textarea name="message"
                    className="contact-message"
                    id="contact-message"
                    placeholder="Message"
                    required />
                </div>
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                />
                {state.succeeded && (
                  <div style={{ backgroundColor: '#7fffd4', color: '#2C926E', padding: '10px', margin: '10px 0' }}>
                    Message envoyé, merci !
                  </div>
                )}
                <button
                  type="submit"
                  className="button button__primary align-items-center"
                  disabled={state.submitting}
                >
                  <span>{contact.btnText}</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    // <!-- ========== Contact section end ========== -->
  );
};

export default Contact;
